import { getCustomWidgetType } from 'reporting-data/report/reportGetters';
export const customWidgetTypeIs = (report, widgetType) => getCustomWidgetType(report) === widgetType;
export const customWidgetTypeIncludes = (report, widgetTypes) => {
  const customWidgetType = getCustomWidgetType(report);
  return customWidgetType && widgetTypes.includes(customWidgetType);
};